export default __webpack_public_path__ + "static/media/IMG-20241210-WA0018.ddc91fa8.jpg";